webpackJsonp([10447256381578210000],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-es2015/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-stage-1/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-react/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-env/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/examples/clear-form.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDripForm = __webpack_require__("../src/index.js");
	
	var _reactDripFormComponents = __webpack_require__("./node_modules/react-drip-form-components/lib/index.js");
	
	var _components = __webpack_require__("./src/components/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-alert */
	/* eslint-disable import/extensions */
	/* eslint-disable import/no-unresolved */
	/* eslint-disable import/no-extraneous-dependencies */
	
	
	var ClearForm = (0, _reactDripForm.dripForm)({
	  validations: {
	    name: {
	      required: true,
	      max: 32
	    },
	    gender: {
	      required: true
	    },
	    colors: {
	      required: true
	    }
	  }
	})(function (_ref) {
	  var handlers = _ref.handlers,
	      _ref$meta = _ref.meta,
	      invalid = _ref$meta.invalid,
	      pristine = _ref$meta.pristine;
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: handlers.onSubmit },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'name' },
	        'Name'
	      ),
	      _react2.default.createElement(_reactDripFormComponents.Input, {
	        type: 'text',
	        id: 'name',
	        name: 'name',
	        label: 'Name'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'label',
	        null,
	        'Gender'
	      ),
	      _react2.default.createElement(
	        _reactDripFormComponents.FieldGroup,
	        { name: 'gender' },
	        _react2.default.createElement(
	          _reactDripFormComponents.Radio,
	          { value: 'female' },
	          'Female'
	        ),
	        _react2.default.createElement(
	          _reactDripFormComponents.Radio,
	          { value: 'male' },
	          'Male'
	        ),
	        _react2.default.createElement(
	          _reactDripFormComponents.Radio,
	          { value: 'other' },
	          'Other'
	        ),
	        _react2.default.createElement(
	          _reactDripFormComponents.Radio,
	          { value: 'none' },
	          'Rather not say'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'label',
	        null,
	        'Favorite Colors'
	      ),
	      _react2.default.createElement(
	        _reactDripFormComponents.FieldGroup,
	        { name: 'colors', multiple: true },
	        _react2.default.createElement(
	          _reactDripFormComponents.Checkbox,
	          { value: 'white' },
	          'White'
	        ),
	        _react2.default.createElement(
	          _reactDripFormComponents.Checkbox,
	          { value: 'black' },
	          'Black'
	        ),
	        _react2.default.createElement(
	          _reactDripFormComponents.Checkbox,
	          { value: 'blue' },
	          'Blue'
	        ),
	        _react2.default.createElement(
	          _reactDripFormComponents.Checkbox,
	          { value: 'red' },
	          'Red'
	        ),
	        _react2.default.createElement(
	          _reactDripFormComponents.Checkbox,
	          { value: 'pink' },
	          'Pink'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _components.Button,
	      {
	        primary: true,
	        onClick: handlers.onSubmit,
	        disabled: invalid || pristine
	      },
	      'Send message'
	    ),
	    ' ',
	    _react2.default.createElement(
	      _components.Button,
	      {
	        onClick: handlers.onClear,
	        disabled: pristine
	      },
	      'Clear'
	    )
	  );
	});
	
	var ClearFormExample = function (_Component) {
	  _inherits(ClearFormExample, _Component);
	
	  function ClearFormExample() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClearFormExample);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ClearFormExample.__proto__ || Object.getPrototypeOf(ClearFormExample)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	      values: {}
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ClearFormExample, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var location = this.props.location;
	      var values = this.state.values;
	
	
	      return _react2.default.createElement(
	        _components.Layout,
	        {
	          title: 'Clear Form',
	          location: location
	        },
	        _react2.default.createElement(
	          'p',
	          null,
	          'It is an example to clear the state of the form.',
	          _react2.default.createElement('br', null),
	          'There are two ways to clear the state.'
	        ),
	        _react2.default.createElement(
	          'ol',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'code',
	              null,
	              'props.handlers.onClear()'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'code',
	              null,
	              'form.clear()'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'In this example we will use method 1.',
	          _react2.default.createElement('br', null),
	          'You can easily implement state clearing by simply specifying ',
	          _react2.default.createElement(
	            'code',
	            null,
	            'handlers.onClear()'
	          ),
	          ' in the handler of the button component ',
	          _react2.default.createElement(
	            'code',
	            null,
	            'onClick'
	          ),
	          '.'
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Example:'
	        ),
	        _react2.default.createElement(ClearForm, {
	          onChange: function onChange(v) {
	            return _this2.setState({ values: v });
	          },
	          onValidSubmit: function onValidSubmit(v) {
	            alert('See console');
	            console.log(v);
	          }
	        }),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Values:'
	        ),
	        _react2.default.createElement(
	          _components.Code,
	          { language: 'javascript' },
	          JSON.stringify(values, null, 2)
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Sample Code:'
	        ),
	        _react2.default.createElement(
	          _components.Code,
	          { language: 'javascript' },
	          'import React from \'react\';\nimport { dripForm } from \'react-drip-form\';\nimport {\n  Input,\n  FieldGroup,\n  Checkbox,\n  Radio,\n} from \'react-drip-form-components\';\n\nconst ClearForm = dripForm({\n  validations: {\n    name: {\n      required: true,\n      max: 32,\n    },\n    gender: {\n      required: true,\n    },\n    colors: {\n      required: true,\n    },\n  },\n})(({\n  handlers,\n  meta: { invalid, pristine },\n}) => (\n  <form onSubmit={handlers.onSubmit}>\n    <div>\n      <label htmlFor="name">Name</label>\n      <Input\n        type="text"\n        id="name"\n        name="name"\n        label="Name"\n      />\n    </div>\n\n    <div>\n      <label>Gender</label>\n      <FieldGroup name="gender">\n        <Radio value="female">Female</Radio>\n        <Radio value="male">Male</Radio>\n        <Radio value="other">Other</Radio>\n        <Radio value="none">Rather not say</Radio>\n      </FieldGroup>\n    </div>\n\n    <div>\n      <label>Favorite Colors</label>\n      <FieldGroup name="colors" multiple>\n        <Checkbox value="white">White</Checkbox>\n        <Checkbox value="black">Black</Checkbox>\n        <Checkbox value="blue">Blue</Checkbox>\n        <Checkbox value="red">Red</Checkbox>\n        <Checkbox value="pink">Pink</Checkbox>\n      </FieldGroup>\n    </div>\n\n    <Button\n      primary\n      onClick={handlers.onSubmit}\n      disabled={invalid || pristine}\n    >\n      Send message\n    </Button>\n\n    {\' \'}\n\n    <Button\n      onClick={handlers.onClear}\n      disabled={pristine}\n    >\n      Clear\n    </Button>\n  </form>\n));\n'
	        )
	      );
	    }
	  }]);
	
	  return ClearFormExample;
	}(_react.Component);
	
	exports.default = ClearFormExample;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-examples-clear-form-js-e78044938165638d5f18.js